export const ROUTES = {
  PROJECTS: {
    MY: '/my-projects',
    NOMENCLATURE: '/my-projects/nomenclature',
    UPLOAD_FILES: '/my-projects/nomenclature/upload-files',
  },
  PROFILE: {
    MY: '/my-profile',
  },
  AUTH: {
    AUTH: '/auth',
    LOGIN: 'auth/login',
    CHECK_MAIL: 'auth/check-mail-register',
    REGISTRATION: 'auth/success/registration-success',
    CHECK_PASSWORD: 'auth/check-mail-password',
    SUCCESS_PASSWORD: 'auth/success/password-success',
  },
  ORDERS: {
    MY: '/my-orders',
  },
  NOTIFICATIONS: '/notifications',
  ADDRESSES: '/addresses',
  REQUISITES: '/requisites',
};
